import html2canvas from "html2canvas";
import { GraphPage } from "../../../graphql/types";
import { UpdatePageScreeShotMutationFn } from "../../graphql/page.hooks";

type DeepPartial<T> = {
  [P in keyof T]?: T[P] extends (infer U)[]
    ? DeepPartial<U>[]
    : T[P] extends object
      ? DeepPartial<T[P]>
      : T[P];
};

export const makePagesScreenShots = async (
  pages: DeepPartial<GraphPage>[],
  makeScreen: UpdatePageScreeShotMutationFn
) => {
  const sizes = {
    maxWidth: 1000,
    maxHeight: 825,

    mobile: {
      width: 400,
      height: 750,
    },
    desktop: {
      width: 1920,
    },
  };

  const sunbox = document.createElement("div");
  Object.assign(sunbox.style, {
    position: "absolute",
    left: "-999999px",
    top: "-999999px",
    transformOrigin: "top left",
    overflow: "hidden",
  } as React.CSSProperties);

  document.body.appendChild(sunbox);

  try {
    for (const {
      id,
      prePublishContentString,
      publishContentString,
      type,
      folder,
    } of pages) {
      const isDesktop = type === 1;
      const content = prePublishContentString || publishContentString;

      sunbox.innerHTML = content;

      await new Promise((r) => setTimeout(r, 800));

      const elementHeight = sunbox.scrollHeight;

      const height = isDesktop
        ? Math.min(elementHeight, sizes.maxHeight)
        : Math.min(elementHeight, sizes.mobile.height);
      const width = isDesktop ? sizes.maxWidth : sizes.mobile.width;
      const scale =
        width / (isDesktop ? sizes.desktop.width : sizes.mobile.width);

      sunbox.style.height = `${height}px`;
      sunbox.style.width = `${width}px`;
      sunbox.style.transform = `scale(${scale})`;

      const wrapper = document.createElement("div");
      wrapper.style.width = `${isDesktop ? sizes.desktop.width : sizes.mobile.width}px`;
      wrapper.style.height = "auto";
      wrapper.style.transform = "none";
      wrapper.innerHTML = content;
      sunbox.innerHTML = "";
      sunbox.appendChild(wrapper);

      const canvas = await html2canvas(sunbox, {
        useCORS: true,
        width,
        height,
        windowWidth: width,
        windowHeight: height,
        scrollX: 0,
        scrollY: 0,
      });

      const newCanvas = document.createElement("canvas");
      newCanvas.width = width;
      newCanvas.height = height;

      const ctx = newCanvas.getContext("2d");
      ctx?.drawImage(canvas, 0, 0, width, height);

      const image = newCanvas.toDataURL("image/jpeg", 0.6);

      await makeScreen({ variables: { id, image, folderId: folder?.id } });

      await new Promise((resolve) => setTimeout(resolve, 500));
    }
  } catch (error) {
    console.error("Screenshot creation error: ", error);
  } finally {
    document.body.removeChild(sunbox);
  }
};
